// src/icons/svgs/audio-pause.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SvgAudioPause = (props, ref) => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 44, height: 44, fill: "none", viewBox: "0 0 44 44", ref, ...props, children: [
  /* @__PURE__ */ jsx("rect", { width: 8, height: 28, x: 12, y: 8, fill: "currentColor", rx: 2 }),
  /* @__PURE__ */ jsx("rect", { width: 8, height: 28, x: 24, y: 8, fill: "currentColor", rx: 2 })
] });
var ForwardRef = forwardRef(SvgAudioPause);
var audio_pause_default = ForwardRef;
export {
  audio_pause_default as AudioPause
};
